import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
  ArrowLeft,
  Edit3,
  Trash2,
  Calendar,
  User,
  Loader2,
  Briefcase,
  ShieldCheck,
  Award,
  Activity
} from 'lucide-react';
import Sidebar from '../../components/Dashboard/Sidebar/Sidebar';
import Header from '../../components/Dashboard/Header/Header';
import styles from '../../styles/MasterView.module.css';
import api from '../../api/axios';
import Breadcrumbs from '../../components/Common/Breadcrumbs/Breadcrumbs';
import Footer from '../../components/Common/Footer/Footer';
import toast from 'react-hot-toast';
import DesignationDrawer from './DesignationDrawer';
import NotFound from '../Error/NotFound';

import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

const MySwal = withReactContent(Swal);

const ViewDesignation = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [designation, setDesignation] = useState(null);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const fetchDesignation = async () => {
    setLoading(true);
    try {
      const response = await api.get(`/designations/${id}`);
      if (response.data.success) {
        setDesignation(response.data.data);
      }
    } catch (error) {
      console.error('Error fetching designation details:', error);
      toast.error('Failed to load designation details');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDesignation();
  }, [id]);

  const handleDelete = () => {
    MySwal.fire({
      title: 'Remove Designation?',
      text: `Are you sure you want to delete ${designation.designation_name}? This action cannot be undone.`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#dc2626',
      cancelButtonColor: '#94a3b8',
      confirmButtonText: 'Yes, remove it'
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await api.delete(`/designations/${designation.id}`);
          if (response.data.success) {
            toast.success('Designation removed successfully');
            navigate('/employees/designations');
          }
        } catch (error) {
          toast.error(error.response?.data?.message || 'Error deleting designation');
        }
      }
    });
  };

  if (loading) {
    return (
      <div className={styles['view-master-container']}>
        <Sidebar isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} />
        <div className={styles['content-wrapper']}>
          <Header onMenuClick={() => setIsSidebarOpen(true)} />
          <div className={styles['loading-container']}>
            <Loader2 size={40} className={styles['spinner']} />
            <p>Analyzing Corporate Hierarchy...</p>
          </div>
        </div>
      </div>
    );
  }

  if (!designation) {
    return <NotFound />;
  }


  return (
    <div className={`${styles['view-master-container']} ${isSidebarOpen ? styles['sidebar-open'] : ''}`}>
      <Sidebar isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} />
      {isSidebarOpen && <div className={styles['sidebar-overlay']} onClick={() => setIsSidebarOpen(false)}></div>}

      <div className={styles['content-wrapper']}>
        <Header onMenuClick={() => setIsSidebarOpen(true)} />

        <main className={styles['main-content']}>
          <Breadcrumbs />

          {/* Page Header */}
          <div className={styles['page-header']}>
            <div className={styles['header-title-section']}>
              <h1>Designation Details</h1>
              <p>Manage corporate job titles, authority levels, and role-based classifications</p>
            </div>
            <div className={styles['header-actions-top']}>
              <button className={styles['btn-secondary']} onClick={() => navigate('/employees/designations')}>
                <ArrowLeft size={18} />
                <span>Back</span>
              </button>
              <button className={styles['btn-primary']} onClick={() => setIsDrawerOpen(true)}>
                <Edit3 size={18} />
                <span>Update Title</span>
              </button>
            </div>
          </div>

          {/* Master Profile Header Card */}
          <div className={styles['master-profile-header']}>
            <div className={styles['header-main']}>
              <div
                className={styles['avatar-large']}
                style={{ background: 'var(--primary-gradient)' }}
              >
                <Award size={32} />
              </div>
              <div className={styles['profile-basic-info']}>
                <div className={styles['title-flex']}>
                  <h1>{designation.designation_name}</h1>
                  <span className={styles['status-badge']}>
                    <ShieldCheck size={14} /> AUTHORIZED ROLE
                  </span>
                </div>
                <div className={styles['master-meta']}>
                  <div className={styles['meta-item']}>
                    <Briefcase size={16} />
                    <span>Classification: <strong>Professional Title</strong></span>
                  </div>
                  <div className={styles['meta-item']}>
                    <Calendar size={16} />
                    <span>Configured: <strong>{new Date(designation.created_at).toLocaleDateString('en-IN', { month: 'long', year: 'numeric' })}</strong></span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Metrics Row */}
          {/* <div className={styles['metrics-row']}>
            <div className={styles['metric-card']}>
              <div className={styles['m-header']}>
                <div className={`${styles['m-icon']} ${styles['bg-blue']}`}><User size={20} /></div>
              </div>
              <div className={styles['m-info']}>
                <label>Headcount</label>
                <h2>14</h2>
              </div>
            </div>
            <div className={styles['metric-card']}>
              <div className={styles['m-header']}>
                <div className={`${styles['m-icon']} ${styles['bg-green']}`}><Activity size={20} /></div>
              </div>
              <div className={styles['m-info']}>
                <label>Open Positions</label>
                <h2>03</h2>
              </div>
            </div>
            <div className={styles['metric-card']}>
              <div className={styles['m-header']}>
                <div className={`${styles['m-icon']} ${styles['bg-orange']}`}><Award size={20} /></div>
              </div>
              <div className={styles['m-info']}>
                <label>Pay Grade</label>
                <h2>Level 4</h2>
              </div>
            </div>
            <div className={styles['metric-card']}>
              <div className={styles['m-header']}>
                <div className={`${styles['m-icon']} ${styles['bg-slate']}`}><ShieldCheck size={20} /></div>
              </div>
              <div className={styles['m-info']}>
                <label>Seniority</label>
                <h2>Mid-Level</h2>
              </div>
            </div>
          </div> */}

          {/* Dashboard Grid */}
          <div className={styles['dashboard-grid']}>
            <div className={styles['left-column']}>
              {/* Hierarchy Details */}
              <div className={styles['standard-card']}>
                <div className={styles['card-header']}>
                  <div className={styles['card-icon']}><Award size={20} /></div>
                  <h3>Hierarchy Mapping</h3>
                </div>
                <div className={styles['details-list']}>
                  <div className={styles['detail-row']}>
                    <div className={styles['detail-item']}>
                      <span className={styles['d-label']}>Official Job Title</span>
                      <span className={styles['d-value']}>{designation.designation_name}</span>
                    </div>
                    <div className={styles['detail-item']}>
                      <span className={styles['d-label']}>Authority Alias</span>
                      <span className={styles['d-value']}>ROLE-{designation.id.toString().padStart(3, '0')}</span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Role-based Activity */}
              {/* <div className={styles['standard-card']}>
                <div className={styles['card-header']}>
                  <div className={styles['card-icon']}><Activity size={20} /></div>
                  <h3>Employment Distribution</h3>
                </div>
                <div style={{ textAlign: 'center', padding: '40px 0', color: '#94a3b8' }}>
                  <p style={{ fontSize: '13px' }}>Distribution of employees across different departments holding this designation will be listed here.</p>
                </div>
              </div> */}
            </div>

            <div className={styles['right-column']}>
              {/* Registry Info */}
              <div className={styles['standard-card']}>
                <div className={styles['card-header']}>
                  <div className={styles['card-icon']}><ShieldCheck size={20} /></div>
                  <h3>System Registry</h3>
                </div>
                <div className={styles['info-block']}>
                  <div className={styles['meta-sidebar-item']}>
                    <div className={styles['sidebar-icon']}><User size={18} /></div>
                    <div className={styles['sidebar-text']}>
                      <label>CONFIGURED BY</label>
                      <span>{designation.creator?.name || 'System Admin'}</span>
                    </div>
                  </div>
                  <div className={styles['meta-sidebar-item']}>
                    <div className={styles['sidebar-icon']}><Calendar size={18} /></div>
                    <div className={styles['sidebar-text']}>
                      <label>SETUP DATE</label>
                      <span>{new Date(designation.created_at).toLocaleDateString('en-IN', { day: '2-digit', month: 'long', year: 'numeric' })}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </main>
      </div>

      <DesignationDrawer
        isOpen={isDrawerOpen}
        onClose={() => setIsDrawerOpen(false)}
        designation={designation}
        onSave={fetchDesignation}
      />
    </div>
  );
};

export default ViewDesignation;
